import React from 'react'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import Typography from '@material-ui/core/Typography'
import {
  Link,
  Theme,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close'
import { TubeProduct } from '../../utils/enum'
const styles = makeStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  rootRow: {
    //  color: theme.palette.grey[500],
    background: '#F2F3F4',
    fontWeight: theme.typography.fontWeightMedium,
    borderBottom: 0,
    padding: theme.spacing(1),
  },
  tableBody: {
    padding: theme.spacing(1),
  },
  table: {
    minWidth: 850,
  },
  dialog: {
    background: '#F2F3F4',
  },
  icon: {
    fontSize: theme.typography.pxToRem(14),
    verticalAlign: 'middle',
    color: theme.palette.grey[700],
  },
  label: {
    fontWeight: 'normal',
    fontSize: theme.typography.pxToRem(14),
    marginBottom: theme.spacing(2),
  },
  clearButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  styleLink: {
    color: theme.palette.primary.main,
  },
}))

export interface DialogTitleProps {
  id: string
  children: React.ReactNode
  onClose: () => void
}

const DialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props
  const classes = styles()
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.clearButton}
          onClick={onClose}
          color="primary"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  )
}

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

interface ModificationProps {
  isValid: boolean
  productType: string
}

const ModifiedSpecPopUp: React.FC<ModificationProps> = (props) => {
  const [open, setOpen] = React.useState(false)
  const isValid = props.isValid
  const { productType } = props
  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  const classes = styles()
  const datas = [
    {
      Scale: '0.05',
      Desalt: '2/60',
      Cartridge: '0.4/12',
      HPLC: '0.4/12',
      Page: '0.2/6',
    },
    {
      Scale: '0.2',
      Desalt: '5/150',
      Cartridge: '1/30',
      HPLC: '1/30',
      Page: '0.4/12',
    },
    {
      Scale: '1.0',
      Desalt: '16/480',
      Cartridge: '5/150',
      HPLC: '5/150',
      Page: '2/60',
    },
    {
      Scale: '10',
      Desalt: '160/4,800',
      Cartridge: 'NA',
      HPLC: '52/1,560',
      Page: 'NA',
    },
    {
      Scale: '15',
      Desalt: '240/7,200',
      Cartridge: 'NA',
      HPLC: '76/2,280',
      Page: 'NA',
    },
  ]

  return (
    <div>
      <Link
        component="button"
        underline={isValid ? 'none' : 'hover'}
        disabled={isValid}
        onClick={handleClickOpen}
        className={classes.styleLink}
      >
        <i>{<FormattedMessage {...messages.CONF_YIELDS_TABLE} />}</i>
      </Link>

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="md"
      >
        <div className={classes.dialog}>
          <DialogTitle id="customized-dialog-title" onClose={handleClose}>
            <b>
              {productType === TubeProduct.Rna ? (
                <FormattedMessage {...messages.CONF_MODIFIED_RNA_OLIGOS} />
              ) : (
                <FormattedMessage {...messages.CONF_MODIFIED_OLIGOS} />
              )}
            </b>
          </DialogTitle>
        </div>

        <DialogContent dividers>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell align="left" className={classes.rootRow}>
                  {<FormattedMessage {...messages.CONF_MODIFIED_SCALE} />}
                </TableCell>
                <TableCell align="left" className={classes.rootRow}>
                  {<FormattedMessage {...messages.CONF_DESALT} />}
                </TableCell>
                <TableCell align="left" className={classes.rootRow}>
                  {<FormattedMessage {...messages.CONF_CARTRIDGE} />}
                </TableCell>
                <TableCell align="left" className={classes.rootRow}>
                  {<FormattedMessage {...messages.HPLC} />}
                </TableCell>
                <TableCell align="left" className={classes.rootRow}>
                  {<FormattedMessage {...messages.CONF_POPUP_PAGE} />}
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {datas.map((data, index) => (
                <TableRow key={index}>
                  <TableCell align="left" className={classes.tableBody}>
                    {data.Scale}
                  </TableCell>
                  <TableCell align="left" className={classes.tableBody}>
                    {data.Desalt}
                  </TableCell>
                  <TableCell align="left" className={classes.tableBody}>
                    {data.Cartridge}
                  </TableCell>
                  <TableCell align="left" className={classes.tableBody}>
                    {data.HPLC}
                  </TableCell>
                  <TableCell align="left" className={classes.tableBody}>
                    {data.Page}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {productType === TubeProduct.Rna ? (
            <FormattedMessage {...messages._PC_SPEC_MODIFIES_RNA_SCALE} />
          ) : (
            <FormattedMessage {...messages._PC_SPEC_MODIFIES_SCALE} />
          )}
        </DialogContent>
      </Dialog>
    </div>
  )
}
export default ModifiedSpecPopUp
